import { useState, useEffect } from 'react';

const useKeyPress = (targetKey: number) => {
  const [keyPressed, setKeyPressed] = useState(false);

  function downHandler(e: any) {
    if (e.keyCode === targetKey) {
      setKeyPressed(true);
    }
  }

  const upHandler = (e: any) => {
    if (e.keyCode === targetKey) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
    // eslint-disable-next-line
  }, []);

  return keyPressed;
};

export default useKeyPress;
